/* Local section navigation only: no requests, dependencies or layout placeholders. */
(() => {
  if (window.MoviwiHomeDirectory) { window.MoviwiHomeDirectory.mount(); return; }
  const mounted = new Map();
  function mount() {
    for (const [nav, dispose] of mounted) if (!nav.isConnected) dispose();
    document.querySelectorAll('[data-home-directory]').forEach(nav => {
      if (mounted.has(nav)) return;
      const controller = new AbortController();
      const { signal } = controller;
      const on = (element, name, handler, options = {}) => element.addEventListener(name, handler, { ...options, signal });
      const toggle = nav.querySelector('[data-directory-toggle]');
      const compact = matchMedia('(max-width:900px)');
      let items = [], frame = 0, headerOffset = 64;
      const setOpen = (open, focus = false) => {
        nav.dataset.open = String(open);
        toggle.setAttribute('aria-expanded', String(open));
        if (focus) toggle.focus({ preventScroll: true });
      };
      const refresh = () => {
        items = Array.from(nav.querySelectorAll('[data-directory-link]')).flatMap(link => {
          const target = document.getElementById(link.hash.slice(1));
          link.parentElement.hidden = !target;
          return target ? [{ link, target }] : [];
        });
        headerOffset = document.querySelector('[data-site-header]')?.getBoundingClientRect().height || 64;
        nav.hidden = items.length < 2;
        schedule();
      };
      const draw = () => {
        frame = 0;
        const marker = headerOffset + Math.min(160, innerHeight * 0.22);
        let current = items[0];
        for (const item of items) if (item.target.isConnected && item.target.getBoundingClientRect().top <= marker) current = item;
        for (const item of items) {
          if (item === current) item.link.setAttribute('aria-current', 'location');
          else item.link.removeAttribute('aria-current');
        }
        // Do not compete with navigation, cart, or newsletter dialogs.
        nav.inert = Boolean(document.querySelector('cart-drawer.active,dialog[open],.site-menu-toggle[aria-expanded="true"],.moviwi-language-disclosure[open]'));
        if (nav.inert) setOpen(false);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(draw); };
      on(window, 'scroll', schedule, { passive: true });
      on(window, 'resize', refresh, { passive: true });
      on(window, 'hashchange', schedule);
      on(window, 'load', refresh, { once: true });
      on(compact, 'change', () => setOpen(false));
      on(toggle, 'click', () => setOpen(nav.dataset.open !== 'true'));
      on(nav, 'click', event => {
        const link = event.target.closest('[data-directory-link]');
        if (!link || !compact.matches) return;
        // Native anchors preserve browser history and reduced-motion preferences.
        setOpen(false, true);
      });
      on(nav, 'keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); setOpen(false, true); }
      });
      on(document, 'pointerdown', event => { if (!nav.contains(event.target)) setOpen(false); });
      on(document, 'focusin', event => { if (!nav.contains(event.target)) setOpen(false); });
      on(document, 'shopify:section:load', refresh);
      on(document, 'shopify:section:unload', () => requestAnimationFrame(refresh));
      // Opening/closing a drawer can happen without a scroll event.
      const observer = new MutationObserver(schedule);
      document.querySelectorAll('cart-drawer,dialog,.site-menu-toggle,.moviwi-language-disclosure').forEach(element => observer.observe(element, { attributes: true, attributeFilter: ['class', 'open', 'aria-expanded'] }));
      const sizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
      if (sizeObserver) sizeObserver.observe(document.getElementById('MainContent') || document.body);
      mounted.set(nav, () => { controller.abort(); observer.disconnect(); sizeObserver?.disconnect(); cancelAnimationFrame(frame); mounted.delete(nav); });
      refresh();
    });
  }
  window.MoviwiHomeDirectory = { mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => { for (const [nav, dispose] of mounted) if (!nav.isConnected || event.target.contains(nav)) dispose(); });
})();
